export default {

  methods: {

    toggler_click() {
      this.$refs.navbar_collapsible.classList.toggle('show');
    },

  },

};
